export default {
  setStudents(state, students) {
    state.students = students;
  },
  setStudent(state, student) {
    state.student = student;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
